var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"px-0 pt-0"},[_c('h3',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }